
import {Vue, Component} from 'vue-property-decorator';
import {DocBook, listDocBook} from '@/service/kk-help-doc/doc-book';
import {hideLoading, showLoading, showWarning} from '@/utils/message';

@Component
export default class DocBookList extends Vue {
  public list: DocBook[] = [];

  public keyword: string = '';

  get filteredList() {
    if (!this.keyword) {
      return this.list;
    }
    return this.list.filter((item) => {
      return item.name.indexOf(this.keyword) !== -1;
    });
  }

  public created() {
    location.href = 'https://docs.qq.com/doc/p/2350f862d89181a2f62c750c8cd556fe707d6d02'
    document.title = '企业大学在线-帮助文档';
    showLoading();
    // listDocBook()
    //     .then((res) => {
    //       this.list = res.sort((o1, o2) => o1.seqNo - o2.seqNo);
    //     })
    //     .catch(showWarning)
    //     .finally(hideLoading);
  }
}
